import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Upload as UploadIcon, X } from 'lucide-react';
import { CAD_FORMATS } from '@/utils/constants';

export function TaskFilesTab({ formData, onChange, canEdit, onImageUpload, uploading, imageUrl, setImageUrl, onImageUrl }) {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold mb-4">Product Image</h3>
        <div className="grid grid-cols-2 gap-6">
          <div>
            {canEdit && (
              <>
                <label htmlFor="image-upload" className="flex items-center justify-center gap-2 px-4 py-2 border rounded-md hover:bg-slate-50 cursor-pointer mb-3">
                  <UploadIcon size={16} /><span className="text-sm">{uploading ? 'Uploading...' : 'Upload Image'}</span>
                </label>
                <input id="image-upload" type="file" accept="image/*" onChange={onImageUpload} disabled={uploading} className="hidden" />
                <div className="flex gap-2">
                  <Input value={imageUrl} onChange={e => setImageUrl(e.target.value)} placeholder="Or paste URL" className="flex-1" />
                  <Button type="button" onClick={onImageUrl} size="sm">Add</Button>
                </div>
              </>
            )}
          </div>
          <div>
            {formData.product_image && (
              <div className="relative aspect-square rounded-md overflow-hidden border">
                <img src={formData.product_image} alt="Product" className="w-full h-full object-cover" />
                {canEdit && (
                  <button type="button" onClick={() => onChange('product_image', '')} className="absolute top-2 right-2 p-1 bg-rose-500 text-white rounded-full"><X size={14} /></button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="border-t pt-6">
        <h3 className="text-lg font-semibold mb-4">CAD Files</h3>
        <div className="grid grid-cols-2 gap-6">
          <div><Label htmlFor="cad_file_name">File Name</Label><Input id="cad_file_name" value={formData.cad_file_name} onChange={e => onChange('cad_file_name', e.target.value)} disabled={!canEdit} className="mt-2" /></div>
          <div>
            <Label htmlFor="cad_file_format">Format</Label>
            <select id="cad_file_format" value={formData.cad_file_format} onChange={e => onChange('cad_file_format', e.target.value)} disabled={!canEdit} className="mt-2 w-full h-10 px-3 border rounded-md bg-white">
              <option value="">Select</option>
              {CAD_FORMATS.map(f => <option key={f.value} value={f.value}>{f.label}</option>)}
            </select>
          </div>
          <div className="col-span-2"><Label htmlFor="cad_server_path">Server Path</Label><Input id="cad_server_path" value={formData.cad_server_path} onChange={e => onChange('cad_server_path', e.target.value)} disabled={!canEdit} className="mt-2 font-mono text-sm" /></div>
        </div>
      </div>
    </div>
  );
}
